module.exports = __webpack_public_path__ + "img/allPlatWelfare.f68ee201.svg";